import { formatDateWithTimeAMPM } from '@/shared';
import { EstadoComponente } from '@/shared/components/ui';
import { EstadosSolicitudPeodidoEnum, SolicitudGremiosComposed } from '@/shared/interfaces';
import { SolicitudExtranjero } from '@/shared/interfaces/erp/solicitud_extranjero/solicitud_extranjero.interface';
import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';


const handleEstado = (estado: string) => {
  switch (estado) {
    case EstadosSolicitudPeodidoEnum.ESPERA:
      return 'blue'
    case EstadosSolicitudPeodidoEnum.APROBADAS:
      return 'green'
    case EstadosSolicitudPeodidoEnum.RECHAZADO:
      return 'red'
    case EstadosSolicitudPeodidoEnum.ABIERTO:
      return 'orange'
    case EstadosSolicitudPeodidoEnum.FINALIZADO:
      return 'gray'
    default:
      return 'black'
  }
}


export const useTableColumnsSolicitudGremios = ({ }: { estado_solicitud: string }) => {


  const columnsBase: MRT_ColumnDef<SolicitudExtranjero>[] = useMemo<
    MRT_ColumnDef<SolicitudExtranjero>[]
  >(
    () => [
      {
        accessorKey: 'identificacion',
        header: 'identificacion',
      },
      {
        accessorKey: 'estado_solicitud',
        header: 'estado_solicitud',
        Cell: ({ row }) => (
          row.original.estado_solicitud != null ?
            <EstadoComponente backgroundColor={handleEstado(row.original.estado_solicitud)} texto={row.original.estado_solicitud} /> : null
        ),
      },
      {
        accessorKey: 'user_create',
        header: 'user_create',
      },
      {
        accessorKey: 'area_create',
        header: 'area_create',
      },
      {
        accessorKey: 'canal_venta_create',
        header: 'canal_venta_create',
      },
      {
        accessorKey: 'user_aprueba',
        header: 'user_aprueba',
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'fecha_creacion',
        Cell: ({ row }) => (
          formatDateWithTimeAMPM(row.original.fecha_creacion)
        ),
      },
    ],
    []
  );


  const columnsGremios: MRT_ColumnDef<SolicitudGremiosComposed>[] = useMemo<
    MRT_ColumnDef<SolicitudGremiosComposed>[]
  >(
    () => [
      {
        accessorKey: 'identificacion',
        header: 'identificacion',
        Cell: ({ row }) => (
          row.original?.prospecto_data?.identificacion
        ),
      },
      {
        accessorKey: 'razon_social',
        header: 'Razón Social',
        Cell: ({ row }) => (
          row.original?.prospecto_data?.razon_social
        ),
      },
      {
        accessorKey: 'estado_solicitud',
        header: 'estado_solicitud',
        Cell: ({ row }) => (
          row.original.estado_solicitud != null ?
            <EstadoComponente backgroundColor={handleEstado(row.original.estado_solicitud)} texto={row.original.estado_solicitud} /> : null
        ),
      },
      {
        accessorKey: 'user_create',
        header: 'user_create',
      },
      {
        accessorKey: 'area_create',
        header: 'area_create',
      },
      {
        accessorKey: 'canal_venta_create',
        header: 'canal_venta_create',
      },
      {
        accessorKey: 'user_aprueba',
        header: 'user_aprueba',
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'fecha_creacion',
        Cell: ({ row }) => (
          formatDateWithTimeAMPM(row.original.fecha_creacion!)
        ),
      },
    ],
    []
  );

  return {
    columnsBase,
    columnsGremios,
  }
}